import { render, staticRenderFns } from "./ShowClientDetails.vue?vue&type=template&id=03104798&"
import script from "./ShowClientDetails.vue?vue&type=script&lang=js&"
export * from "./ShowClientDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports